import { AgentInput } from './interfaces';

const updateTimeout = (input: AgentInput): number => {
  const {
    chunk: { vals },
    primingData: { timeout }
  } = input;
  vals.start = typeof vals.start !== undefined ? vals.start : performance.now();
  return timeout - (performance.now() - vals.start);
};

export default updateTimeout;
